export default __webpack_public_path__ + "static/material_ui-3ba90d7054d148a470102cd246a0e218.svg";